import { apiRequest } from '../Api/ApiRequest';


const SwaggerService = {
  access: () => {
    return apiRequest({
      url: `/swagger-ui/access`,
      method: 'get',
      headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
    }).catch(error => error)
  }
}

export default SwaggerService;